import mixpanel, { Dict } from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || '';

const getPagePrefix = (pathname: string): string => {
  if (pathname.includes('/improvement-center')) {
    return 'IMPC';
  }
  if (pathname.includes('/dashboard')) {
    return 'DSH';
  }
  return 'PROD';
};

const track = (name: string, props?: Dict) => {
  if (MIXPANEL_TOKEN) {
    mixpanel.track(name, {
      group: 'AI Signal',
      ...props,
    });
  }
};

const trackPageView = (location: string) => {
  track('AIS:PAGE_VIEW', {
    route: location,
  });
};

let replayHolders = 0;
let replayTimer: ReturnType<typeof setTimeout> | undefined;
let replayRetryTimer: ReturnType<typeof setTimeout> | undefined;

const applySessionReplay = () => {
  if (!MIXPANEL_TOKEN) return;
  clearTimeout(replayTimer);
  clearTimeout(replayRetryTimer);
  replayTimer = setTimeout(() => {
    if (replayHolders > 0) {
      mixpanel.start_session_recording();
      return;
    }
    mixpanel.stop_session_recording();
    // A recording left from before a page reload is resumed asynchronously,
    // so stop it once more when no recorded page is mounted.
    replayRetryTimer = setTimeout(() => {
      if (replayHolders === 0) mixpanel.stop_session_recording();
    }, 2000);
  }, 0);
};

const startSessionReplay = () => {
  replayHolders += 1;
  applySessionReplay();
};

const stopSessionReplay = () => {
  replayHolders = Math.max(0, replayHolders - 1);
  applySessionReplay();
};

type UserSource = 'XOVI' | 'Standalone' | 'Partner';

const setUserSource = (source: UserSource) => {
  if (MIXPANEL_TOKEN) {
    mixpanel.people.set({ source });
  }
};

const identifyUser = (userId: string) => {
  if (MIXPANEL_TOKEN) {
    mixpanel.identify(userId);
    mixpanel.register({ userId });
  }
};

const resetUser = () => {
  if (MIXPANEL_TOKEN) {
    mixpanel.reset();
  }
};

export type { UserSource };
export {
  MIXPANEL_TOKEN,
  track,
  trackPageView,
  getPagePrefix,
  applySessionReplay,
  startSessionReplay,
  stopSessionReplay,
  setUserSource,
  identifyUser,
  resetUser,
};
